/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-09-27                                                        *
 ******************************************************************************/

import ConfigurationTemplateVersion from "../../business-objects/configuration-template-version";
import QuoteProduct from "../../business-objects/quote-product";
import IsSelected from "../../enums/is-selected";
import YesNo from "../../enums/yes-no";

export default {
    props:{
        initializeTemplate:{
            type: Boolean,
            default: true
        }
    },
    data() {
        let version = new ConfigurationTemplateVersion();
        let product = new QuoteProduct();
        product.configuration_template_version = version;
        return {
            template_version: version,
            quote_product: product,
            is_loading_template: false,
            IsSelected:IsSelected,
            YesNo:YesNo
        };
    },
    computed:{
        configuration_template_id(){
            if(this.templateId){
                return this.templateId
            }else if(this.$route){
                return this.$route.params.template_id
            }
        }
    },
    created() {
        this.loadItem();
    },
    methods: {
        loadItem() {
            this.is_loading_template = true;
            this.$store.dispatch('ConfigurationTemplatesStore/show_all', this.configuration_template_id)
                .then((template_version)=>{
                    this.template_version.buildFromJson(template_version);
                    if(this.initializeTemplate){
                        this.template_version.initialize();
                    }
                })
                .catch((error) => {
                    alert(error.response ? error.response.data : error);
                })
                .finally(() => {
                    this.is_loading_template = false;
                });
        }
    }
}
